var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiochemistry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99976 16L10.784 12.8808M10.784 12.8808L16.8462 16.3808M10.784 12.8808L10.7062 6.01553M16.8462 16.3808L16.8462 23M16.8462 16.3808L21.8372 13.5741C22.453 13.2279 23.2058 13.2321 23.8175 13.5854L27.9998 16",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18.5L7.00001 20.8453C7.00002 21.5598 7.38121 22.2201 8.00001 22.5773L9.39488 23.3827C10.0503 23.7611 10.8632 23.7371 11.4952 23.3208L13.5 22",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiochemistry);
export default __webpack_public_path__ + "static/media/Biochemistry.fc98576841b0026539837cc436aa02a9.svg";
export { ForwardRef as ReactComponent };